// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  type Element,
  type Node,
  useState,
} from 'react';

import { useSize } from '@zapier/design-system-company/src/utils';
import { Text, Typography } from '@zapier/design-system';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {
  /** The main content of the banner */
  children: Node,
  /** The link text */
  linkText: string,
  /** The modal component to show when the link is clicked */
  modal: Element<*>,
  /** The callback to execute when the modal closes. */
  onClose?: () => void,
  /** Shows the modal by default when true. */
  showModalByDefault: boolean,
};

const Styles = labelStyles(__filename, {
  root: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
  },

  link: {
    ...Typography.altText900,
    color: 'white',
    textDecoration: 'underline',
  },

  linkWrapper: size => [
    {
      marginTop: 5,
      position: 'relative',
      textAlign: 'center',
    },
    size &&
      withModifier(
        size,
        {
          large: {
            marginTop: 0,
            position: 'absolute',
            right: 0,
            top: 0,
          },
          medium: {},
          small: {},
        }[size]
      ),
  ],
});

const BannerWithModal = (props: Props) => {
  const [modalIsOpen, setModalIsOpen] = useState(props.showModalByDefault);
  const size = useSize();

  return (
    <div css={Styles.root}>
      <Text color="white" tag="div" type="altText900">
        {props.children}
      </Text>

      <button
        css={Styles.linkWrapper(size)}
        onClick={() => setModalIsOpen(true)}
      >
        <span css={Styles.link}>{props.linkText}</span>
      </button>

      {modalIsOpen &&
        React.cloneElement(props.modal, {
          ...props,
          onClose: () => {
            if (props.onClose) props.onClose();
            setModalIsOpen(false);
          },
          size,
        })}
    </div>
  );
};

export default BannerWithModal;
